import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import LocalizedText from '@LocalizedText';
import { inject } from '@app/providers/QAU.ContextProvider';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { checkShapeIsEquilateral, isStickerFlow } from '@app/utils/utils';

import SvgIconUse from '@SvgIconUse';
import Button from '@components/buttons/Button';
import SizeToolGroup from '../tools/size-tool-group/SizeToolGroup';

const SizeGroup = ({ flowConfig, flow, context, editor, canvasReady, isEquilateralShape, toggleOverlay, visible, currentFlow, ...props }) => {
  const [preactivated, setPreactivated] = useState(false);
  const sizeGroupBtnRef = useRef();

  const sizeLayout = (
    <div id="qau-toolgroup-size" className={classnames({ equilateral: isEquilateralShape })}>
      <SizeToolGroup />
    </div>
  );

  useEffect(() => {
    const { current: sizeGroupBtn } = sizeGroupBtnRef;
    const canBePreactivated = visible && canvasReady && !preactivated;

    if (canBePreactivated) {
      sizeGroupBtn.click();
      setPreactivated(true);
      editor.autoZoom();
    }
  }, [editor, visible, preactivated, canvasReady]);

  return (
    visible && (
      <Button ref={sizeGroupBtnRef} onClick={e => toggleOverlay(e, sizeLayout)} {...props}>
        <SvgIconUse id="label" />
        <LocalizedText id={`qau-toolgroup-${currentFlow}`} tagName="span" />
      </Button>
    )
  );
};

const mapStateToProps = (
  {
    customize: {
      customizeData: {
        resizeParams: { shape },
      },
    },
  },
  { flow: { editor }, context, flowConfig },
) => ({
  canvasReady: !!editor?.panelCfg && !!context,
  editor,
  currentFlow: isStickerFlow(flowConfig) ? 'sticker' : 'label',
  isEquilateralShape: checkShapeIsEquilateral(shape),
});

SizeGroup.propTypes = {
  editor: PropTypes.object,
  visible: PropTypes.bool.isRequired,
  canvasReady: PropTypes.bool.isRequired,
  toggleOverlay: PropTypes.func.isRequired,
  currentFlow: PropTypes.string.isRequired,
  isEquilateralShape: PropTypes.bool.isRequired,
};

export default inject('flowConfig', 'flow', 'context')(connect(mapStateToProps, {})(SizeGroup));
